<template>
  <div class="layout-box">
    <div class="head-wh">
      <div class="title-center"><span>{{ headtitle }}</span></div>
     <AccountInfo :keepalives="kls" ></AccountInfo><!-- :permissions="permissions"-->
    </div>
    <div class="secondary-content">
      <div class="pdwk-l">
        <div class="pdwk-l-t">
          <div style="height: 100%; width: 420px; display: inline-block; padding: 15px 10px 5px 15px; box-sizing: border-box">
            <Echartring :configs="myconfigring6" ref="myconfigring6"></Echartring>
          </div>
          <div style="display: inline-block; width: 420px; height: 100%; vertical-align: bottom">
            <h3 style="text-align: center; color: #F4F7FF ; font-size: 19px; padding-top: 10px">本月设备维修订单</h3>
            <div class="clinch-deal-list">
              <p><span>#</span><span>设备</span><span>维修时间</span><span>状态</span></p>
              <ul>
                <vue-seamless-scroll :data="workAll.repairs" :class-option="classOption" class="seamless-warp">
                  <li v-for="(item,index) in workAll.repairs" :key="index"><span><em>{{ index+1 }}</em></span><span>#{{ item.machineCode }}</span><span :title="item.repairTime">{{ item.repairTime }}</span><span><el-button type="info" size="mini" plain>{{ item.repairType }}</el-button></span></li>
                </vue-seamless-scroll>
              </ul>
            </div>
          </div>
        </div>
        <div class="pdwk-l-b">
          <div class="summary">
            <h2>今日产量：{{ outPut.meters||'--' }}km，{{outPut.output||'--'}}t</h2>
            <p>设备汇总值，汇总设备<a>33</a>台，停机<a>{{numb1}}</a>台，正常运行<a>{{numb2}}</a>台</p>
          </div>
          <div class="workshop">
            <div class="workshop-one">
              <ul>
                <li v-for="(item,index) in equipList.slice(0,12)" :class="getisrunings(item.isRunning)==0?'error-st':''" :key="item.equipmenid" @click="clickgetdtail(item.machineId,index+1,item.machineType)" :style="timer==index+1?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="getisrunings(item.isRunning)==0"></i>
                    <div class="hint" v-if="getisrunings(item.isRunning)==0">
                      <p>{{ index+1 }}号机</p>
                      <p>停{{ item.runtime }}分</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="workshop-two">
              <ul>
                <li v-for="(item,index) in equipList.slice(12,22)" :class="getisrunings(item.isRunning)==0?'error-st':''" :key="item.equipmenid" @click="clickgetdtail(item.machineId,index+13,item.machineType)" :style="timer==index+13?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="getisrunings(item.isRunning)==0"></i>
                    <div class="hint" v-if="getisrunings(item.isRunning)==0">
                      <p>{{ index+13 }}号机</p>
                      <p>停{{ item.runtime }}分</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="workshop-three">
              <ul>
                <li v-for="(item,index) in equipList.slice(22,25)" :class="getisrunings(item.isRunning)==0?'error-st':''" :key="item.equipmenid" @click="clickgetdtail(item.machineId,index+23,item.machineType)" :style="timer==index+23?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="getisrunings(item.isRunning)==0"></i>
                    <div class="hint" v-if="getisrunings(item.isRunning)==0">
                      <p>{{ index+23 }}号机</p>
                      <p>停{{ item.runtime }}分</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="workshop-four">
              <ul>
                <li v-for="(item,index) in equipList.slice(25,33)" :class="getisrunings(item.isRunning)==0?'error-st':''" :key="item.equipmenid" @click="clickgetdtail(item.machineId,index+26,item.machineType)" :style="timer==index+26?'background: rgba(222,217,20,0.75);':''">
                  <div class="point-st">
                    <em class="halo"></em>
                    <i class="line" v-if="getisrunings(item.isRunning)==0"></i>
                    <div class="hint" v-if="getisrunings(item.isRunning)==0">
                      <p>{{ index+26 }}号机</p>
                      <p>停{{ item.runtime }}分</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="oee-s">
            <div>
              <p><countTo :startVal='0' :endVal='82.9' :decimals="1" :duration='8000'></countTo><em>%</em></p>
              <a>本月开机率</a>
            </div>
            <div>
              <p><countTo :startVal='0' :endVal='81.8' :decimals="1" :duration='8000'></countTo><em>%</em></p>
              <a>当日开机率</a>
            </div>
            <div>
              <p><countTo :startVal='0' :endVal='99.3' :decimals="1" :duration='8000'></countTo><em>%</em></p>
              <a>当日有效开机率</a>
            </div>
          </div>
        </div>
      </div>
      <div class="pdwk-r">
        <div class="device-info" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.3)">
          <div class="device-info-title">#{{ timer }}机器运行情况<i class="run-st" :class="getisrunings(machineDetail.isRunning)>0?'':'run-st-error'"></i></div>
          <div class="device-infos device-info-six">
            <div class="point-st" style="top: 338px;left: 816px;"><em class="halo"></em><i class="line" style="transform: rotate(-150deg); height: 160px"></i><div class="hint" style="top: -184px; left: 80px"><p>卷径4:{{ machineDetail.meters||0 }}mm</p><p>卷重4:{{ machineDetail.speed||0 }}g</p></div></div>
            <div class="point-st" style="top: 380px;left: 485px;"><em class="halo"></em><i class="line" style="transform: rotate(-247deg);height: 155px"></i><div class="hint" style="top: -102px; left: -140px"><p>卷径1:{{ machineDetail.meters||0 }}mm</p><p>卷重1:{{ machineDetail.speed||0 }}g</p></div></div>
            <div class="point-st" style="top: 358px;left: 665px;"><em class="halo"></em><i class="line" style="transform: rotate(-155deg); height: 200px"></i><div class="hint" style="top: -226px; left: 80px"><p>卷径2:{{ machineDetail.meters||0 }}mm</p><p>卷重2:{{ machineDetail.speed||0 }}g</p></div></div>
            <div class="point-st" style="top: 344px;left: 762px;"><em class="halo"></em><i class="line" style="transform: rotate(-58deg); height: 99px"></i><div class="hint" style="top: 54px; left: 80px"><p>卷径3:{{ machineDetail.meters||0 }}mm</p><p>卷重3:{{ machineDetail.speed||0 }}g</p></div></div>
            <div class="point-st" style="top: 385px;left: 349px;"><em class="halo"></em><i class="line" style="transform: rotate(80deg); height: 120px"></i><div class="hint" style="top: -0px; left: -180px"><p>卷绕速度:{{ machineDetail.gb2||0 }}m/min</p><p>锭重:{{ machineDetail.gb2||0 }}kg</p></div></div>
            <div class="point-st" style="top: 202px;left: 395px;"><em class="halo"></em><i class="line" style="transform: rotate(-260deg); height: 180px"></i><div class="hint" style="top: -76px; left: -180px"><p>纺丝间距:1000mm</p><p>螺杆尺寸:120/25</p></div></div>
            <div class="point-st" style="top: 276px;left: 665px; background: none;"><div class="hint" style="top: -265px; "><p>生产：{{ machineDetail| categorys}}米/分钟</p></div></div>
            <div class="point-st" style="top: 316px;left: 665px; background: none;"><div class="hint" style="top: -265px; "><p>规格：{{ machineDetail| specifications}}毫米</p></div></div>
          </div>
        </div>
        <div class="device-info-st" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.3)">
          <div style="width: 175px" :class="getisrunings(workDetail.machineDetail.isRunning)>0?'':'breathing'">
            <h2 style="width: 100%;text-align: center">{{workDetail.machineDetail.isRunning}}</h2>
            <p v-if="getisrunings(workDetail.machineDetail.isRunning)==0"><span style="font-size: 24px">{{ workDetail.machineDetail.runtime }}分钟</span></p>
          </div>
          <div style="width: 265px">
            <h3 style="text-align: center;padding-top: 4px">当前订单</h3>
            <p style="margin-top: 3px"><span style="width: 100px; display: inline-block; text-align: right">落筒时间：</span>{{ workDetail.machineDetail.modifyTime | parseTimes}}</p>
            <p style="margin-top: 2px" :title="workDetail.machineDetail.produceCloth"><span style="width: 100px; display: inline-block; text-align: right">品类：</span>{{ machineDetail | categorys }}</p>
          </div>
          <div style="width: 525px">
            <p style="padding-top: 18px"><span style="width: 110px; display: inline-block; text-align: right; line-height: 21px">单品进度：</span><em class="skill-line"><i :style="{width:(machineDetail.procSingle>100?100:(machineDetail.procSingle||0))+'%'}">{{ machineDetail.procSingle||0}}% </i></em></p>
            <p style="margin-top: 10px"><span style="width: 110px; display: inline-block; text-align: right">批号：</span>{{ machineDetail.id | floorrandom}}</p>
          </div>
        </div>
        <div class="device-info-temperature" id="echart_temperature" v-show="showline"></div>
        <div class="device-info-temperature" style="display: flex; justify-content: space-between;"  v-if="machineDetail.machineType!='JB'">
          <div style="width: 50%">
            <h3 style="text-align: center; color: #F4F7FF ; font-size: 16px; padding-top: 10px">上料记录</h3>
            <div class="clinch-deal-list">
              <p><span>#</span><span style="flex: none;">物料类型</span><span style="flex: none;">上料时间</span><span style="flex: none;">下料时间</span></p>
              <ul style="height: 210px">
                <vue-seamless-scroll :data="feedList" :class-option="classOption" class="seamless-warp">
                  <li v-for="(item,index) in feedList" :key="index"><span style="flex: none;"><em>{{ index+1 }}</em></span><span style="flex: none;" :title="item.produceCard">{{ item.panHead }}</span><span style="flex: none;" :title="item.feedingTime">{{ item.feedingTime }}</span><span style="flex: none;" :title="item.downTime">{{ item.downTime }}</span></li>
                </vue-seamless-scroll>
              </ul>
            </div>
          </div>
          <div style="width: 50%">
            <h3 style="text-align: center; color: #F4F7FF ; font-size: 16px; padding-top: 10px">机台任务</h3>
            <div class="clinch-deal-list">
              <p><span>#</span><span style="flex: none;">生产卡</span><span style="flex: none;">预计开始</span><span style="flex: none;">预计结束</span><span style="flex: none;">状态</span></p>
              <ul style="height: 210px">
                <vue-seamless-scroll :data="taskList" :class-option="classOption" class="seamless-warp">
                  <li v-for="(item,index) in taskList" :key="index"><span><em>{{ index+1 }}</em></span><span style="flex: none;">#{{ item.produceCard }}</span><span style="flex: none;" :title="item.startTime">{{ item.startTime }}</span><span style="flex: none;" :title="item.endTime">{{ item.endTime }}</span><span style="flex: none;"><el-button type="success" size="mini" plain>{{ item.status }}</el-button></span></li>
                </vue-seamless-scroll>
              </ul>
            </div>
          </div>
        </div>
        </div>
      </div>
  </div>
</template>

<script>
import AccountInfo from '../layout/account-info'
import Echartring from '../../components/echart-ring'
import countTo from 'vue-count-to'
import {debounce} from '../../bll/utils'
import pinyin from 'js-pinyin'
pinyin.setOptions({checkPolyphone: false, chartCase: 0})
export default {
  name: 'spinningworkshop',
  components: {
    AccountInfo,
    Echartring,
    countTo
  },
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  filters: {
    maintenances (status) {
      let name = ''
      switch (status * 1) {
        case 0:
          name = '未派单'
          break
        case 1:
          name = '已派单'
          break
        case 2:
          name = '正在处理'
          break
        case 3:
          name = '已结单'
          break
        default:
          name = '未接收'
      }
      return name
    },
    parseTimes (t) {
      return t ? t.replace('T', ' ') : ''
    },
    floorrandom (t) {
      return t ? 'FS'+t*1779 : ''
    },
    categorys(data){
      let name,types,n=data.procProduce*1;
      name=data.machineType=='JB'?'POY':'FDY'
      switch (true) {
        case n>200:
          types='200D'
          break;
        case n>150:
          types='150D'
          break;
        case n>75:
          types='75D'
          break;
        case n>50:
          types='50D'
          break;
        default:
          types='30D'
      }
      return name+types
    },
    specifications(data){
      let name,types,n=data.procProduce*1;
      name=data.machineType=='JB'?'POY':'FDY'
      switch (true) {
        case n>200:
          types=name=='POY'?'380dtex/288F':'222dtex/30F'
          break;
        case n>150:
          types=name=='POY'?'260dtex/144F':'183dtex/96F'
          break;
        case n>75:
          types=name=='POY'?'120dtex/72F':'83dtex/72F'
          break;
        case n>50:
          types=name=='POY'?'100dtex/24F':'56dtex/24F'
          break;
        default:
          types=name=='POY'?'60dtex/48F':'31dtex/2F'
      }
      return types
    },
    percentage (wd) {
      let pd = 0
      if (wd.plantime && wd.plantime * 1 != 0) {
        pd = Math.round((wd.plantime - wd.runtime) * 100 / wd.plantime)
      }
      // this.widths=pd>100?100:pd
      return pd > 100 ? 100 : pd
    },
    transcoding (name) {
      return pinyin.getCamelChars(name)
    },
    machineType(ty){
      return ty=='JB'?'经编机':(ty=='JT'?'加弹机':'整经机')
    }
  },
  data () {
    return {
      headtitle: '化纤数智纺丝车间',
      kls: false,
      loading: true,
      permissions: [1],
      myconfigring6: {
        id: 'num6',
        text: '纺丝品类',
        seriesleft: '20%',
        seriesdata: [],
        name: '品类'
      },
      deviceid: '',
      timer: 1,
      showline: false,
      ty: 0,
      getdatasid: '',
      workAll: {
        equipOee: 0
      },
      equipList: [],
      workDetail: {
        clothList: [{
          cycle: '',
          ringnum: '',
          status: ''
        }, {
          cycle: '',
          ringnum: '',
          status: ''
        }],
        machineDetail: {
          machineType: '',
          runtime: '',
          procProduce: 0,
          isRunning: '',
          extend1: '',
          machineCode: '',
          meters: '',
          modifyTime: '',
          produceCloth: '',
          procSingle: 0
        }
      },
      machineDetail:{},
      speedList:[
        {axisCollect:'',lineCollect:''},
        {axisCollect:'',lineCollect:''},
        {axisCollect:'',lineCollect:''},
        {axisCollect:'',lineCollect:''},
        {axisCollect:'',lineCollect:''},
        {axisCollect:'',lineCollect:''},
        {axisCollect:'',lineCollect:''}
      ],
      tempList:[
        {measureA:'',measureB:'',measureDown:''},
        {measureA:'',measureB:'',measureDown:''},
        {measureA:'',measureB:'',measureDown:''},
        {measureA:'',measureB:'',measureDown:''},
        {measureA:'',measureB:'',measureDown:''},
        {measureA:'',measureB:'',measureDown:''},
        {measureA:'',measureB:'',measureDown:''},
        {measureA:'',measureB:'',measureDown:''},
        {measureA:'',measureB:'',measureDown:''},
        {measureA:'',measureB:'',measureDown:''},
        {measureA:'',measureB:'',measureDown:''},
        {measureA:'',measureB:'',measureDown:''}
      ],
      extendList:{
        scope:'',
        speed:''
      },
      outPut:{},
      equipInfoTwo: {},
      $_resizeHandler: null,
      $_timergetdata: null,
      widths: '',
      surface:true, //true a面 false B面
      $_goinsurface:null,
      blank:[],
      feedList:[],
      taskList:[],
      numb1:0,
      numb2:0
    }
  },
  created () {
    localStorage.setItem('gotourl', window.location.hash)
  },
  computed: {
    classOption () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000// 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  mounted () {
    const $this = this
    setTimeout(function () {
      $this.getdata()
    },500)
    this.$_resizeHandler = debounce(() => {
      this.getworkdetail()
    }, 500)
    $this.dataRefresh.$ons('Refresh', () => {
      $this.workAll = {
        equipOee: 0
      }
      $this.getdata()
    })
  },
  methods: {
    getdata () {
      const url = '/api-portal/zx/mill'
      const $this = this
      this.$api.get(url, {}, (response) => {
        let datas = response.data || ''
        $this.equipList = []
        const namess=['75D','150D','50D','30D','200D']
        if (datas) {
          $this.workAll = datas.data
          datas.data.JT.splice(5)
          datas.data.ZJ.splice(10)
          $this.equipList = [...datas.data.ZJ, ...datas.data.JT, ...datas.data.JB]
          $this.equipList.splice(33)
          $this.equipList.map(item=>{
            let st=$this.getisrunings(item.isRunning)
            st>0?$this.numb2++:$this.numb1++
          })
          $this.myconfigring6.seriesdata = ($this.workAll.blank).map((itme,index) => {
            return {name: namess[index], value: itme.val}
          })
          $this.blank=($this.workAll.blank).map(itme => {
            return {name: itme.type, rate: itme.rate, lastRate: itme.lastRate}
          })
          //临时处理方案
          $this.blank.splice(5)
          $this.myconfigring6.seriesdata.splice(5)
          //临时处理方案 end
          $this.$refs.myconfigring6.echartring()
          $this.outPut=$this.workAll.outPut[0]
          $this.getdatasid = $this.equipList[0].machineId
          $this.ty = $this.equipList[0].machineType
          $this.getworkdetail()
        }
      })
      $this.$_timergetdata = setInterval(function () {
        if ($this.timer >= 33) {
          $this.timer = 0
        }
        $this.timer += 1
        $this.getdatasid = $this.equipList[$this.timer - 1].machineId
        $this.ty = $this.equipList[$this.timer - 1].machineType
        $this.$_resizeHandler()
      }, 90000)
    },
    calculate (dw) {
      return this.$options.filters['percentage'](dw)
    },
    clickgetdtail (id, num, ty) {
      if (id != this.getdatasid) {
        this.getdatasid = id
        this.timer = num
        this.ty = ty || 'JB'
        this.$_resizeHandler()
      }
    },
    getworkdetail () {
      const $this = this
      const url1 = '/api-portal/zx/detail'
      this.loading = true
      this.$api.get(url1, {machineId: $this.getdatasid, machineType: $this.ty, isManual: 1}, (response) => {
        let datas = response.data || ''
        if (datas) {
          $this.workDetail = datas.data
          $this.machineDetail = $this.workDetail.machineDetail
          if($this.machineDetail.machineType=='JT'){
            $this.extendList=$this.workDetail.extendList[0]||{}
            if(($this.workDetail.speedList).length>0){
              $this.speedList=$this.workDetail.speedList
            }
            if(($this.workDetail.tempList).length>0){
              $this.tempList=$this.workDetail.tempList
            }
            if($this.$_goinsurface!=null){
              clearInterval($this.$_goinsurface)
              $this.$_goinsurface = null
            }
            $this.$_goinsurface= setInterval(function () {
              $this.surface=$this.surface==false
            }, 15000)
          }else {
            clearInterval($this.$_goinsurface)
            $this.$_goinsurface = null
          }
          if($this.machineDetail.machineType!='JB'){
            if($this.workDetail.feedList){
              $this.feedList=$this.workDetail.feedList
            }
            if($this.workDetail.taskList){
              $this.taskList=$this.workDetail.taskList
            }
          }
          const noline = datas.data.outPutList || []
          if (noline.length > 0) {
            if($this.machineDetail.machineType=='JB'){
              $this.showline = true
            }
            let datas1=[],datas2=[],times=[]
            noline.map(val=>{
              datas1.push(val.output)
              datas2.push(val.saleQuantity)
              times.push(val.date)
            })
            setTimeout(function () {
              $this.drawlinediagram(datas1,datas2,times)
            }, 500)
          } else {
            $this.showline = false
          }
          if (datas.data.equipInfoTwo) {
            $this.equipInfoTwo = datas.data.equipInfoTwo
          }
        }
        this.loading = false
      })
    },
    drawlinediagram (data1,data2,t) {
      const myEchartst = this.$echarts.init(document.getElementById('echart_temperature'))
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'<br/>'
              str += `${item.marker}${item.seriesName}: ${item.data} t`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          axisLine: {
            lineStyle: {
              color: '#5788EC'
            }
          },
          data: t
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          max: function (value) {
            return value.max
          },
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#5788EC'
            }
          },
          axisLabel: {
            color: '#C1D3F4'
          }
        },
        series: [
          {
            name: '产量',
            type: 'line',
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: 'rgb(255, 70, 131)'
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(255, 158, 68)'
                },
                {
                  offset: 1,
                  color: 'rgb(255, 70, 131)'
                }
              ])
            },
            data: data1
          },
          {
            name: '销售数量',
            type: 'line',
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: '#21D88C'
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#288BE8'
                },
                {
                  offset: 1,
                  color: '#21D88C'
                }
              ])
            },
            data: data2
          }
        ]
      }
      myEchartst.setOption(option)
    },
    getisrunings(name){
      let st = ''
      switch (name) {
        case '维护停机':
        case '失联':
        case '换盘头停机':
        case '质量(断纱)停机':
        case '其他停机':
        case '失去连接':
        case '换布停机':
          st = 0
          break
        default:
          st = 1
      }
      return st
    }
  },
  beforeDestroy () {
    const $this = this
    clearInterval($this.$_timergetdata)
    $this.$_timergetdata = null
  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 1080px;
  overflow: auto;
  background: #001346 url("../../assets/secondary/bg-4.png") no-repeat center bottom;
}
.head-wh{
  height: 147px;
  background: url("../../assets/secondary/title.png") no-repeat center top;
}
.title-center{
  font-size: 36px;
  font-family:"fzskjt";
  color: #D2DFFF;
  font-style: italic;
  padding-top: 15px;
  text-shadow: 3px 2px 7px rgba(0,0,0,0.65);
  line-height: 200%;
  text-align: center;
}

.secondary-content{
  width: 100%;
  height: calc(100% - 90px);
  margin-top: -57px;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pdwk-r{
  width: 1033px;
  height: 990px;
  margin-top: -18px;
  background: url("../../assets/secondary/border-7.png") no-repeat center top;
}

.pdwk-l-t{
  width: 849px;
  height: 274px;
  margin-left: 19px;
  background: url("../../assets/secondary/border-3.png") no-repeat center/100%;
}

.pdwk-l-b{
  width: 887px;
  height: 727px;
  margin-top: -12px;
  padding-top: 20px;
  box-sizing: border-box;
  background: url("../../assets/secondary/border-4.png") no-repeat center bottom;
}

.clinch-deal-list{
  padding: 10px 16px 10px 12px;
  color: #fff;
  font-size: 14px;
}

.clinch-deal-list p,.clinch-deal-list li{
  display: flex;
  justify-content: space-between;
}

.clinch-deal-list p{
  border-bottom: 1px solid #1E60B9;
  padding-bottom: 8px;
}

.clinch-deal-list li{
  height: 38px;
  line-height: 38px;
  font-size: 12px;
  background: rgba(47,62,183,0.9);
}

.clinch-deal-list li:nth-child(even){
  background: rgba(20,36,108,0.9);
}

.clinch-deal-list ul{
  height: 180px;
  overflow: hidden;
}

.clinch-deal-list span{
  text-align: left;
  display: inline-block;
  overflow:hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
  flex: 1;
}

.clinch-deal-list em{
  width: 21px;
  height: 21px;
  border-radius: 50%;
  border: 1px solid #04357D;
  background: #0544A3;
  text-align: center;
  font-style: normal;
  line-height: 21px;
  display: inline-block;
  box-shadow: 1px 2px 2px rgba(0,0,0,0.35);
}

.clinch-deal-list span:first-child{
  width: 45px;
  text-align: center;
  flex: none;
}

.clinch-deal-list span:nth-child(2){
  width: 85px;
  flex: none;
  text-align: center;
}

.clinch-deal-list span:nth-child(3){
  width: 120px;
}

.clinch-deal-list span:nth-child(4){
  flex: none;
  width: 95px;
}

.summary{
  width: 716px;
  height: 85px;
  background: url("../../assets/secondary/border-5.png") no-repeat center/100%;
  margin: 0 auto;
  color: #fff;
  font-weight: bold;
  font-family: fzskjt;
  line-height: 85px;
  text-align: center;
}

.summary h2{
  background: linear-gradient(to bottom, #fff,#fff,#FDDD60,#FDDD60, #fff);
  -webkit-background-clip:text;
  padding-top: 22px;
  margin-bottom: 10px;
  line-height: 100%;
  font-size: 21px;
  color:transparent;
}

.summary p{
  background: linear-gradient(to bottom,#8EFFFF,#8EFFFF, #fff,#fff,#8EFFFF);
  -webkit-background-clip:text;
  line-height: 100%;
  font-size: 16px;
  color:transparent;
}

.workshop{
  width: 824px;
  height: 413px;
  margin-left: 35px;
  margin-top: 55px;
  position: relative;
  background: url("../../assets/secondary/fscj.png") no-repeat center/100%;
}

.workshop ul{
  height: 100%;
  width: 100%;
}

.workshop li{
  position: relative;
  border-radius: 6px;
  cursor: pointer;
  /*background: rgba(154,125,25,0.75);*/
  display: flex;
  justify-content: center;
  align-items: center;
}

.workshop-one{
  width: 295px;
  height: 155px;
  position: absolute;
  top: 60px;
  left: 170px;
}

.workshop-one li{
  width: 81px;
  height: 37px;
  margin-right: 5.5px;
  margin-left: 1.9px;
  margin-bottom: 5px;
  float: left;
  transform:skewX(-3deg);
}

.workshop-one li:nth-child(1){
  margin-left: 18px;
}
.workshop-one li:nth-child(4){
  margin-left: 9px;
}
.workshop-one li:nth-child(7){
  margin-left: 4px;
}

.workshop-two{
  width: 233px;
  height: 200px;
  position: absolute;
  top: 20px;
  left: 455px;
  padding-left: 8px;
  box-sizing: border-box;
}

.workshop-two li{
  width: 76px;
  height: 37px;
  margin-right: 7px;
  margin-bottom: 4px;
  float: left;
  transform:skewX(6deg);
}

.workshop-two li:nth-child(3){
  margin-left: 11px;
}

.workshop-two li:nth-child(5){
  margin-left: 22px;
}

.workshop-two li:nth-child(7){
  margin-left: 32px;
}

.workshop-two li:nth-child(9){
  margin-left: 43px;
}

.workshop-three{
  width: 339px;
  height: 45px;
  position: absolute;
  top: 266px;
  left: 141px;
}

.workshop-three li{
  width: 79px;
  height: 40px;
  margin-right: 28px;
  float: left;
}

.workshop-four{
  width: 640px;
  height: 40px;
  position: absolute;
  top: 345px;
  left: 50px;
}

.workshop-four li{
  width: 70px;
  height: 44px;
  float: left;
}

.workshop-four li:nth-child(6){
  margin-left: 58px;
}

.oee-s{
  width: 100%;
  height: 90px;
  margin: 0 auto;
  margin-top: 45px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

.oee-s>div{
  width: 167px;
  height: 88px;
  box-sizing: border-box;
  margin: 1px 2px;
  padding-top: 42px;
  background: url("../../assets/secondary/border-6.png") no-repeat center/100%;
  text-align: center;
}

.oee-s>div:nth-child(2){
  width: 197px;
  height: 103.8px;
  margin-top: -12px;
}

.oee-s span{
  font-size: 36px;
  color: #FFC926;
  font-weight: bold;
  font-family: Bahnschrift;
  display: inline-block;
  text-shadow: 3px 2px 7px rgba(0,0,0,0.65);
}

.oee-s em{
  font-size: 14px;
  color: #FFC926;
  font-family: Arial;
}

.oee-s>div:nth-child(1) span,.oee-s>div:nth-child(3) span{
  color: #FC7001;
  font-size: 30px;
  padding-top: 3px;
}

.oee-s>div:nth-child(1) em,.oee-s>div:nth-child(3) em{
  color: #FC7001;
}

.oee-s a{
  font-size: 14px;
  margin-top: -8px;
  color: #D2E4FE;
  display: block;
}

.point-st{
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #0f0;
  position: relative;
}

.workshop-one .point-st{
  transform:skewX(3deg);
}

.workshop-two .point-st{
  transform:skewX(-6deg);
}
.workshop-five .point-st,.workshop-six .point-st{
  transform:skewX(-8deg);
}

.halo{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #0f0;
  animation: flicker_halo 1.5s infinite
}

.line{
  width: 5px;
  height: 32px;
  border-left: 1px solid rgb(220, 20, 60);
  position: absolute;
  top: 1px;
  left: 3px;
  transform: translate(-50%,-50%);
  transform: rotate(-195deg);
  transform-origin: left top
}

.hint{
  position: absolute;
  left: -10px;
  top: -70px;
  transform:translateX(-50%);
  padding: 6px 4px;
  border: 1px solid rgb(220, 20, 60);
  background-color: rgba(220, 20, 60, 0.35);
  display: inline-block;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  z-index: 20;
  color: #fff;
}

/*.workshop li:nth-child(even) .line{*/
/*  height: 53px;*/
/*  top: 2px;*/
/*  transform: rotate(60deg);*/
/*}*/

/*.workshop li:nth-child(even) .hint{*/
/*  left: -50px;*/
/*  top: 28px;*/
/*}*/

.workshop-two li:nth-child(even) .line,
.workshop-one li:nth-child(n+4):nth-child(-n+6) .line,
.workshop-one li:nth-child(n+10):nth-child(-n+12) .line{
  height: 42px;
  top: 2px;
  transform: rotate(-125deg);
}
.workshop-two li:nth-child(even) .hint,
.workshop-one li:nth-child(n+4):nth-child(-n+6) .hint,
.workshop-one li:nth-child(n+10):nth-child(-n+12) .hint{
  left: 50px;
  top: -62px;
}

/*.workshop-three li:nth-child(2) .line{*/
/*  height: 32px;*/
/*  top: 1px;*/
/*  transform: rotate(-205deg);*/
/*}*/

/*.workshop-three li:nth-child(2) .hint{*/
/*  left: -10px;*/
/*  top: -68px;*/
/*}*/

.error-st .point-st{
  background: #FF0229;
}
.error-st .halo{
  background: #FF0229;
}

.device-info{
  width: 100%;
  height: 590px;
}

.device-info-title{
  width: 365px;
  height: 103px;
  padding-top: 9px;
  background: url("../../assets/secondary/border-8.png") no-repeat center bottom;
  margin: 0 auto;
  font-size: 26px;
  color: #fff;
  font-weight: bold;
  line-height: 92px;
  text-align: center;
  position: relative;
}

.run-st{
  width: 103px;
  height: 8px;
  background: url("../../assets/secondary/bj-5.png") no-repeat 0 0;
  position: absolute;
  left: 50%;
  margin-left: -51px;
  bottom: 6px;
  animation: flicker_run-st 1s infinite
}

.run-st-error{
  background-position: 0 -7px;
}

.device-infos{
  width: 980px;
  height: 453px;
  margin-left: 21px;
  margin-top: 22px;
  border-bottom: 2px solid #D5CFCE;
  position: relative;
}

.device-info-six{
  background: url("../../assets/secondary/device-6.png") no-repeat center bottom;
}

.device-info .point-st{
  position: absolute;
  background: #A8CCFD;
}

.device-info .halo{
  width: 8px;
  height: 8px;
  background: #4DD2FF;
}

.device-info .line{
  border-left: 1px solid #468DF9;
  width: 0px;
  height: 130px;
  left: 3px;
  border-right: 1px solid rgba(0,0,0,0.15);
  transform: rotate(-180deg);
}

.device-info .hint{
  border: 1px solid #3584F9;
  font-size: 12px;
  left: 0px;
  background-color: rgba(8, 91, 215, 0.45);
  box-shadow: 2px 4px 6px rgba(0,0,0,0.35);
  top:-170px;
  transition: all 1.5s ease;
}

.device-info .error-st .halo{
  background: #FF0229;
}

.device-info .error-st .line{
  border-left: 1px solid #FF0229;
}

.device-info .error-st .hint{
  background-color: rgba(220, 20, 60, 0.45);
  border: 1px solid #FF0229;
}

.device-info-temperature{
  height: 280px;
}

.device-info-st{
  width: 100%;
  height: 87px;
  display: flex;
  padding: 0 12px 0 21px;
  box-sizing: border-box;
  justify-content: space-between;
  color: #fff;
}

.device-info-st>div{
  border: 1px solid #4B74ED;
  background: #0D2A81;
}

.device-info-st>div:nth-child(1){
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.device-info-st p{
  overflow:hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
}

.breathing{
  color: #FF3314;
  animation: flicker_breathing 1s infinite
}

.skill-line{
  display: inline-block;
  width: 340px;
  height: 21px;
  background:#0531B4;
  border-radius: 5px;
}

.skill-line i{
  height: 100%;
  display: inline-block;
  text-align: right;
  line-height: 21px;
  font-style: normal;
  background: linear-gradient(to right,#154EF7,#288BE8);
  padding-right: 3px;
  box-sizing: border-box;
  border-radius: 5px;
  position: relative;
}

.skill-line i:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  border-radius: 10px;
  opacity: 0;
  animation: active3_4 3.4s cubic-bezier(.43,1,.52,1) infinite;
  content: " "
}

@keyframes flicker_halo {
  0% {
    transform: scale(1);
    opacity: .9
  }

  to {
    transform: scale(5);
    opacity: .0
  }
}

@keyframes flicker_run-st {
  0% {
    transform: scale(0.7);
    opacity: 1
  }

  to {
    transform: scale(1.1);
    opacity: .8
  }
}

@keyframes flicker_breathing {
  0% {
    opacity: 1
  }
  70%{
    opacity: 0.6
  }
  to {
    opacity: .9
  }
}

@keyframes active3_4 {
  0% {
    width: 0;
    opacity: .1
  }

  20% {
    width: 0;
    opacity: .5
  }

  to {
    width: 100%;
    opacity: 0
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Ld-screen/spinning-workshop.vue